export const SEARCH_COOKIE = 'ha-trip-prst';
